export const PAGE_SIZE = 8;

export const SIDEBAR_ITEMS = [
  { key: "dashboard", label: "Dashboard", icon: "dashboard", permissionKey: "dashboard" },
  { key: "employees", label: "Employees", icon: "employees", permissionKey: "employees" },
  { key: "departments", label: "Departments", icon: "departments", permissionKey: "departments" },
  { key: "designations", label: "Designations", icon: "designation", permissionKey: "designations" },
  { key: "tasks", label: "Tasks", icon: "tasks", permissionKey: "tasks", notificationCategory: "tasks" },
  { key: "attendance", label: "Attendance", icon: "attendance", permissionKey: "attendance", notificationCategory: "attendance" },
  { key: "leaves", label: "Leaves", icon: "leaves", permissionKey: "leaves", notificationCategory: "leave" },
  { key: "payroll", label: "Payroll", icon: "payroll", permissionKey: "payroll", notificationCategory: "payroll" },
  { key: "documents", label: "Documents", icon: "documents", permissionKey: "documents", notificationCategory: "documents" },
  { key: "complaints", label: "Complaints", icon: "complaints", permissionKey: "complaints", notificationCategory: "complaints" },
  { key: "chat", label: "Chat", icon: "chat", permissionKey: "chat", notificationCategory: "chat" },
  {
    key: "announcements",
    label: "Announcements",
    icon: "announcements",
    permissionKey: "announcements",
    notificationCategory: "announcements",
  },
  { key: "reports", label: "Reports", icon: "reports", permissionKey: "reports" },
  { key: "settings", label: "Settings", icon: "settings", permissionKey: "settings" },
];

export const ADMIN_ACCESS_ITEMS = [
  ...SIDEBAR_ITEMS.map(({ permissionKey, label }) => ({
    key: permissionKey,
    label,
  })),
  { key: "notifications", label: "Notifications" },
];

export const createAdminPermissionState = (enabled = true) =>
  Object.fromEntries(
    ADMIN_ACCESS_ITEMS.map((item) => [item.key, Boolean(enabled)])
  );

export const ADMIN_ROLE_OPTIONS = [
  { value: "admin", label: "Admin" },
  { value: "super_admin", label: "Super Admin" },
];

export const DEPARTMENTS = [
  "Design",
  "HR",
  "Development",
  "Marketing",
  "Finance",
  "Sales",
  "Operations",
];

export const ROLE_OPTIONS = ["Employee", "Team Lead", "Manager", "HR Admin"];
export const EMPLOYMENT_TYPES = ["Full Time", "Part Time", "Contract", "Intern"];
export const PAY_FREQUENCIES = ["Monthly", "Bi-Weekly", "Weekly"];
export const GENDER_OPTIONS = ["Male", "Female", "Other"];
export const MARITAL_STATUS_OPTIONS = ["Single", "Married", "Other"];
export const COUNTRY_OPTIONS = ["India", "United States", "United Kingdom", "Canada"];
export const STATE_OPTIONS = [
  "Madhya Pradesh",
  "Maharashtra",
  "Delhi",
  "Karnataka",
  "Tamil Nadu",
  "Gujarat",
];

export const DOCUMENT_FIELDS = [
  { key: "aadhaarCard", label: "Aadhaar Card" },
  { key: "panCard", label: "PAN Card" },
  { key: "resumeCv", label: "Resume/CV" },
  { key: "educationalCertificate", label: "Educational Certificate" },
  { key: "otherDocument", label: "Other Document" },
];

export const INITIAL_LOGIN_FORM = {
  email: "",
  password: "",
  rememberMe: true,
};

export const INITIAL_ADMIN_USER_FORM = {
  fullName: "",
  email: "",
  username: "",
  password: "",
  confirmPassword: "",
  role: "admin",
  permissions: createAdminPermissionState(true),
};

export const INITIAL_EMPLOYEE_FORM = {
  fullName: "",
  email: "",
  username: "",
  loginPassword: "",
  phoneNumber: "",
  dateOfBirth: "",
  gender: "",
  maritalStatus: "",
  department: "",
  designation: "",
  role: "",
  dateOfJoining: "",
  employmentType: "",
  workShiftStart: "09:00",
  workShiftEnd: "18:00",
  reportingManager: "",
  basicSalary: "",
  houseRentAllowance: "",
  conveyanceAllowance: "",
  specialAllowance: "",
  providentFund: "",
  professionalTax: "",
  incomeTax: "",
  payFrequency: "",
  taxRegime: "Old Regime",
  bankName: "",
  accountNumber: "",
  ifscCode: "",
  panNumber: "",
  uanNumber: "",
  pfNumber: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  pinCode: "",
  country: "India",
};

export const INITIAL_FILE_STATE = {
  profilePhoto: null,
  aadhaarCard: null,
  panCard: null,
  resumeCv: null,
  educationalCertificate: null,
  otherDocument: null,
};

export const INITIAL_DEPARTMENT_FORM = {
  name: "",
  description: "",
  departmentHeadName: "",
  departmentHeadTitle: "",
  status: "active",
};

export const DEPARTMENT_PAGE_SIZE_OPTIONS = [5, 10, 20];

export const INITIAL_DESIGNATION_FORM = {
  name: "",
  department: "",
  level: "L1",
  description: "",
  status: "active",
};

export const DESIGNATION_LEVEL_OPTIONS = ["L1", "L2", "L3", "L4", "L5", "L6"];
export const DESIGNATION_PAGE_SIZE_OPTIONS = [5, 10, 20];
